export default {
  id: 128,
  title: 'Target #128 - Letter N',
  url: 'https://cssbattle.dev/play/128',
  colors: ['#998235', '#0B2429', '#FCBE5C'],
  solution:
    '<a a><a b><a c><style>[a],[c]{width:40;height:230;background:#0b2429}body{background:#998235}a{position:fixed}[a]{bottom:70;right:135}[b]{top:70;left:179;width:42;height:160;background:#fcbe5c;transform:skew(20deg)}[c]{top:70;left:135}</style>',
}
